import { FC } from 'react';

/** @deprecated */
const LifeSaverIcon: FC = () => (
  <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M7.38209 14H0.663086V11H7.36609"
      stroke="black"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.6636 17.2656V23.9996H10.6636V17.2656"
      stroke="black"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16.9291 11H23.6631V14H16.9131"
      stroke="black"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.6631 7.719V1H13.6631V7.735"
      stroke="black"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.1636 12.5C17.1636 15.261 14.9246 17.5 12.1636 17.5C9.40057 17.5 7.16357 15.261 7.16357 12.5C7.16357 9.739 9.40057 7.5 12.1636 7.5C14.9246 7.5 17.1636 9.739 17.1636 12.5V12.5Z"
      stroke="black"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.6631 2.10742C18.2611 2.76642 21.8981 6.40142 22.5561 11.0004"
      stroke="black"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M1.76855 11.0004C2.42655 6.40142 6.06355 2.76642 10.6626 2.10742"
      stroke="black"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.6635 22.894C6.06353 22.237 2.42753 18.6 1.76953 14"
      stroke="black"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M22.5561 14C21.8991 18.6 18.2611 22.237 13.6631 22.894"
      stroke="black"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default LifeSaverIcon;
